export const SummaryTableStyle:React.CSSProperties = {
  margin: "20px",
  display: "flex",
  padding: "24px",
  alignItems: "center",
  gap: "24px",
  borderRadius: "8px",
  border: "1px solid #C5C6C5",
  background: "#F6F6F8",
  alignSelf:"center",
  width:"auto"
}

export const SummaryItemStyle:React.CSSProperties = {
  display: "flex",
  alignItems: "flexStart",
  gap: "8px",
  color: "#333333"
}

export const SummaryAmountStyle:React.CSSProperties = {
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "28px"
}